import { Component, inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

@Component({
    selector: 'app-frequently-questions',
    templateUrl: './frequently-questions.component.html',
    styleUrls: ['./frequently-questions.component.scss'],
    standalone: false
})
export class FrequentlyQuestionsComponent {
  private msalService = inject(MsalService);


  userIsLogged = this.msalService.instance.getActiveAccount() !== null;

  redirecTo = ( url: string ) => window.open( url );

}
